import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LuBike, LuArrowRight } from "react-icons/lu";
import { getCustomerOrdersHistory } from "../../api/profile";
import { setComponentActive, updateHistoryOrder } from "../../reducers/userConfigSlice";
import "./style.css";

const CustomerActiveOrders = () => {
  const dispatch = useDispatch();
  const [result, setResult] = useState({ orders: [], loading: true, error: false });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let alive = true;
    let pending = false;
    const refresh = async () => {
      if (pending || document.visibilityState === "hidden") return;
      pending = true;
      try {
        const response = await getCustomerOrdersHistory();
        if (response?.error || !Array.isArray(response?.data)) throw new Error("orders unavailable");
        if (alive) setResult({ orders: response.data.filter(order => order.status === "inDelivery" && order.orderId), loading: false, error: false });
      } catch {
        // Do not keep asserting an old delivery state after a failed refresh.
        if (alive) setResult({ orders: [], loading: false, error: true });
      } finally { pending = false; }
    };
    refresh();
    const timer = window.setInterval(refresh, 10000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      alive = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [attempt]);
  if (result.loading) return <p className="eats-orders-status" role="status">Consultando tus pedidos…</p>;
  if (result.error) return <div className="eats-orders-status" role="status">No hemos podido consultar tus pedidos. <button type="button" onClick={() => { setResult({ orders: [], loading: true, error: false }); setAttempt(value => value + 1); }}>Reintentar</button></div>;
  if (!result.orders.length) return null;
  return <div className="eats-active-orders">{result.orders.map(order => {
    const number = order.displayNumber ?? order.number;
    return <section key={order.orderId} className="eats-active-order" aria-label={`Pedido en camino${number != null ? ` ${number}` : ""}`}>
      <div className="eats-active-order-copy">
        <span className="eats-active-order-label">Pedido activo</span>
        <h2>En camino</h2>
        {number != null && <p>Pedido #{number}</p>}
        <Link to={`/order-tracking/${encodeURIComponent(order.orderId)}`} onClick={() => {
          dispatch(updateHistoryOrder(order));
          dispatch(setComponentActive(`order-tracking/${order.orderId}`));
        }}>Ver seguimiento <LuArrowRight aria-hidden="true" /></Link>
      </div>
      <LuBike className="eats-active-order-icon" aria-hidden="true" />
    </section>;
  })}</div>;
};

export const ActiveOrders = () => {
  const { logged, sessionReady, logoutPending, userData, token } = useSelector(state => state.aplicationConfig.userConfig);
  const info = useSelector(state => state.aplicationConfig.corporationData.info);
  const tenant = info?.corporation?.corporationId ?? info?.corporationId;
  if (!logged || !sessionReady || logoutPending || !userData?.customerId || !tenant) return null;
  // Remount before rendering another session's results, including a same-user re-login.
  return <CustomerActiveOrders key={JSON.stringify([tenant, userData.customerId, token])} />;
};
